//src/components/forIndependentSolutionsData.js
import ReachMorePatient from '../assets/attract_more_patient.jpg';
import CareDelivery from '../assets/Deliver_better_care.jpg';
import patientJourney from '../assets/Enhance_your_patient_experience.jpg';
import RevenueGeneration from '../assets/get_paid_faster.jpg';
import DataManagement from '../assets/Manage_records_digitally.jpg';
import independentImplementation from '../assets/automate_your_practice.jpg';

const forIndependentSolutionsData = [
    {
        id: 1,
        title: "Reach more patients",
        text: "In a digital era, where 90% of patients evaluate doctors online before scheduling appointments, make a lasting first impression. Reach new patients and nurture existing ones through a responsive, SEO-optimized website, search marketing tools, automated reputation management, polished web profiles, and effective social media management.",
        image: ReachMorePatient,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Unified Patient Journey",
        text: "Respond to patient preferences, as nearly 80% express a willingness to switch doctors for added convenience. Empower your staff to deliver a patient-centered experience through features like online scheduling, appointment reminders, digital patient intake forms, text messaging, and a secure patient portal.",
        image: patientJourney,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Contemporary Care Delivery",       
        text: "Enhance clinical efficiency throughout the patient journey with Doclivo, a certified, cloud-based EHR crafted by healthcare providers. Seamlessly integrated with the Doclivo platform, it is driven by intelligent automation and real-time patient insights. Doclivo's care delivery solutions encompass provider scheduling, clinical notes, flowsheets, electronic prescriptions, electronic labs, telehealth, and a secure mobile application, enabling the delivery of modern care from any location.",
        image: CareDelivery,
        buttonLabel: "Learn more",
    },
    {
        id: 4,
        title: "Accelerate Revenue Generation",
        text: "Addressing a common industry challenge where nearly 50% of providers struggle to collect patient balances within 30 days, and 71% of consumers find medical bills confusing. Unlock profitability and efficiency in revenue cycle management with our billing and payment solutions. This comprehensive approach includes intuitive practice management, intelligent process automation, and modern patient payment solutions.",
        image: RevenueGeneration,
        buttonLabel: "Learn more",
    },
    {
        id: 5,
        title: "Enhanced Data Management",
        text: "Minimize operating costs and enhance decision-making with Doclivo's data and insights solutions. This encompasses practice growth and revenue analytics, HIPAA-compliant data cloud storage, and APIs facilitating integration with third-party applications.",
        image: DataManagement,
        buttonLabel: "Learn more",
    },
    {
        id: 6,
        title: "Streamlined Implementation Process",
        text: "Transitioning to a new platform may seem daunting, but with Doclivo, there's no need to fear change. We make switching easy, ensuring your practice experiences a seamless transition. Your dedicated onboarding manager will facilitate a swift setup, offering best-in-class training and enrollment support for you and your team. Doclivo is committed to providing the resources, time, and support necessary for your success.",
        image: independentImplementation,
        buttonLabel: "Learn more",
    },
    
   
    // Add more items as needed

];

export default forIndependentSolutionsData;